import React from 'react'
import { ActivityIndicator, Pressable } from 'react-native'

import { Stack } from '@zet/design-system'
import { styled } from 'nativewind'

import { M16 } from '../typography'

const StyledButton = styled(Pressable)

interface IProps {
  color: string
  title: string
  disabled?: boolean
  onPress: () => void
  loading: boolean
  loaderText?: string
  loaderColor?: string
}

export const Button: React.FC<IProps> = ({
  color = 'bg-primary-100',
  title = '',
  onPress = () => null,
  disabled = false,
  loading = false,
  loaderText = '',
  loaderColor = '#000',
}) => {
  return (
    <Stack className="px-3 pb-4 pt-2 shadow-2xl">
      {disabled ? (
        <Stack className="absolute bottom-0 left-0 right-0 top-0 z-10 bg-[#fff] opacity-50" />
      ) : null}
      <StyledButton
        disabled={disabled}
        className={`items-center rounded-3xl px-2 py-3 ${color}`}
        onPress={onPress}
      >
        {loading ? (
          <Stack
            className="py-[1]"
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'row',
            }}
          >
            {loaderText && (
              <M16 className="text-tertiary-100 mr-2">{loaderText}</M16>
            )}
            <ActivityIndicator color={loaderColor} />
          </Stack>
        ) : (
          <M16>{title}</M16>
        )}
      </StyledButton>
    </Stack>
  )
}
